import { Building2, Wrench, ClipboardCheck, Check } from "lucide-react";
import Reveal from "@/components/Reveal";
import { IMAGES } from "@/data/content";
import { useLanguage } from "@/i18n/LanguageContext";

const SERVICE_META = {
  construcoes: { icon: Building2, image: IMAGES.steelFrame },
  reformas: { icon: Wrench, image: IMAGES.reformas },
  gestao: { icon: ClipboardCheck, image: IMAGES.gestao },
};

const Services = () => {
  const { t } = useLanguage();

  return (
    <section id="servicos" data-testid="services-section" className="bg-[#F8FAFC] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
        <Reveal>
          <p className="font-mono-tech text-xs uppercase tracking-[0.35em] text-emerald-600">
            {t.services.eyebrow}
          </p>
          <h2 className="font-display mt-4 max-w-2xl text-3xl font-bold tracking-tight text-[#07120C] sm:text-4xl lg:text-5xl">
            {t.services.title}
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
            {t.services.lead}
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          {t.services.items.map((service, i) => {
            const meta = SERVICE_META[service.id];
            return (
              <Reveal key={service.id} delay={i * 0.12}>
                <article
                  data-testid={`service-card-${service.id}`}
                  className="group h-full overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-all duration-500 hover:-translate-y-2 hover:border-emerald-500/40 hover:shadow-xl hover:shadow-emerald-500/10"
                >
                  <div className="relative h-52 overflow-hidden">
                    <img
                      src={meta.image}
                      alt={service.alt}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#07120C]/60 to-transparent" />
                    <span className="absolute bottom-4 left-4 flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-500 text-[#07120C]">
                      <meta.icon className="h-5 w-5" />
                    </span>
                  </div>
                  <div className="p-7">
                    <h3 className="font-display text-xl font-semibold text-[#07120C] sm:text-2xl">
                      {service.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-slate-600">{service.desc}</p>
                    <ul className="mt-5 space-y-2.5">
                      {service.bullets.map((item) => (
                        <li key={item} className="flex items-start gap-2.5 text-sm text-slate-700">
                          <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
